import React, { ChangeEvent, useCallback, useMemo } from 'react';
import { Button, Col, FormControl, InputGroup, ListGroupItem, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import useProductQueries from '../../hooks/useProductQueries';
import {
    decrementSkuSelectedQuantity,
    incrementSkuSelectedQuantity,
    selectOneSkuSelectedQuantity,
    setSkuSelectedQuantity,
} from '../../slices/skusSelected';
import './ProductList.scss';

interface Props {
    productId: number;
    skuId: number;
}

const ProductListSku = (props: Props) => {
    const dispatch = useDispatch();

    const productsQueries = useProductQueries();

    const sku = useMemo(() => (
        productsQueries.data?.find((product) => product.id === props.productId)
            .skus.find((sku) => sku.id === props.skuId)
    ), [props.productId, props.skuId, productsQueries]);

    const quantity = useSelector(
        useCallback(selectOneSkuSelectedQuantity(sku.number), [sku?.number])
    );

    const handleIncrement = useCallback(() => {
        dispatch(incrementSkuSelectedQuantity(sku.number));
    }, [sku?.number]);

    const handleDecrement = useCallback(() => {
        dispatch(decrementSkuSelectedQuantity(sku.number));
    }, [sku?.number]);

    const handleSetQuantity = useCallback((e: ChangeEvent<HTMLInputElement>) => {
        dispatch(setSkuSelectedQuantity(sku.number, +e.target.value));
    }, [sku?.number]);

    return sku && <ListGroupItem>
        <Row>
            <Col xs={6} className="sku-name">
                {sku.name}
            </Col>
            <Col xs={6}>
                <InputGroup>
                    <Button
                        variant="outline-secondary"
                        onClick={handleDecrement}
                    >-</Button>
                    <FormControl
                        type="number"
                        value={quantity}
                        onChange={handleSetQuantity}
                    />
                    <Button
                        variant="outline-secondary"
                        onClick={handleIncrement}
                    >+</Button>
                </InputGroup>
            </Col>
        </Row>
    </ListGroupItem>;
}

export default ProductListSku;
